import {createContext, useCallback, useContext} from "react";
import * as actions from '../store/checkout';
import {useDispatch, useSelector} from "react-redux";


export const CustomerDataContext = createContext({
    email: '',
    fetchCustomer: () => {
    },
    billingAddress: {},
    savedPaymentMethods: [],
    setBillingEmail: () => {
    },
    setBillingAddress: () => {
    }
});

export const CustomerDataProvider = ({children}) => {
    const dispatch = useDispatch();
    const customer = useSelector(state => state.checkout.customer);
    const {email, firstName, lastName, mfa, billingEmail, billingAddress, savedPaymentMethods} = customer;
    const fetchCustomer = useCallback(() => {
        return dispatch(actions.fetchCustomer());
    }, []);

    const clearCustomerData = useCallback(() => {
        dispatch(actions.resetCustomer());
    }, [dispatch]);

    const setBillingAddress = useCallback((address) => {
        dispatch(actions.customer.setBillingAddress(address));
    }, [dispatch]);

    const setBillingEmail = useCallback((value) => {
        dispatch(actions.customer.setBillingEmail(value));
    }, [
        email,
        dispatch
    ]);

    const context = {
        email,
        firstName,
        lastName,
        mfa,
        billingEmail,
        billingAddress: {...billingAddress},
        savedPaymentMethods,
        fetchCustomer,
        clearCustomerData,
        setBillingAddress,
        setBillingEmail
    }
    return (
        <CustomerDataContext.Provider value={context}>
            {children}
        </CustomerDataContext.Provider>
    )
}

export const useCustomerDataContext = () => useContext(CustomerDataContext);
